import { render, staticRenderFns } from "./Picos.vue?vue&type=template&id=27730fa2"
import script from "./Picos.vue?vue&type=script&lang=js"
export * from "./Picos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports